import { Card, CardContent } from "@/components/ui/card";
import { Users, Zap, ChevronDown, ChevronUp } from "lucide-react";

export function IndividualSection({ round, expandedIndividual, setExpandedIndividual, isVuelta1 }) {
  if (!round?.individual_matchups?.length) return null;

  return (
    <>
      <h3 className="text-sm font-bold text-[#0F172A] mb-3 flex items-center gap-2">
        <Users className="w-4 h-4 text-blue-600" />
        Individuales
      </h3>
      <Card className="card-default mb-6 overflow-hidden">
        <CardContent className="p-0">
          {round.individual_matchups.map((matchup, index) => {
            const isExpanded = expandedIndividual === index;
            return (
              <div key={matchup.matchup_id || index}>
                <button
                  className={`w-full flex items-center justify-between py-2.5 px-3 text-left border-b border-gray-100 last:border-0 ${matchup.is_doubled ? 'bg-blue-50' : ''}`}
                  onClick={() => setExpandedIndividual(isExpanded ? null : index)}
                  data-testid={`individual-toggle-${index}`}
                >
                  <div className="flex-1 min-w-0 text-xs">
                    {matchup.is_doubled && <Zap className="w-3 h-3 text-blue-600 inline mr-0.5" />}
                    <span className="font-medium text-[#0F172A]">{matchup.player1_name?.split(' ')[0]}</span>
                    <span className="text-[#64748B] mx-1">vs</span>
                    <span className="font-medium text-[#0F172A]">{matchup.player2_name?.split(' ')[0]}</span>
                    <span className="text-[10px] text-[#64748B] ml-2">
                      V1:{matchup.vuelta1_points > 0 ? '+' : ''}{matchup.vuelta1_points || 0} V2:{matchup.vuelta2_points > 0 ? '+' : ''}{matchup.vuelta2_points || 0}
                    </span>
                  </div>
                  <div className="flex items-center gap-1.5">
                    <span className={`text-base font-bold min-w-[32px] text-right ${matchup.total_points > 0 ? 'text-green-600' : matchup.total_points < 0 ? 'text-red-600' : 'text-gray-500'}`}>
                      {matchup.total_points > 0 ? '+' : ''}{matchup.total_points}
                    </span>
                    {isExpanded ? <ChevronUp className="w-3 h-3 text-[#64748B]" /> : <ChevronDown className="w-3 h-3 text-[#64748B]" />}
                  </div>
                </button>

                {isExpanded && Object.keys(matchup.hole_results || {}).length > 0 && (
                  <div className="px-3 pb-3 bg-gray-50/50">
                    <p className="text-[10px] text-[#64748B] py-1">Ventaja: {matchup.handicap_difference} a {matchup.advantage_to === 'player1' ? matchup.player1_name?.split(' ')[0] : matchup.advantage_to === 'player2' ? matchup.player2_name?.split(' ')[0] : 'Ninguno'}</p>
                    {[1, 2].map(vuelta => {
                      const vHoles = Object.entries(matchup.hole_results).filter(([hole]) =>
                        vuelta === 1 ? isVuelta1(parseInt(hole)) : !isVuelta1(parseInt(hole))
                      ).sort(([a], [b]) => parseInt(a) - parseInt(b));
                      if (vHoles.length === 0) return null;
                      return (
                        <div key={vuelta} className="mt-1">
                          <p className="text-[10px] font-bold text-[#64748B]">{vuelta === 1 ? '1ra' : '2da'} Vuelta</p>
                          <div className="flex flex-wrap gap-1 mt-1">
                            {vHoles.map(([hole, r]) => (
                              <div
                                key={hole}
                                className={`w-8 h-8 rounded text-[10px] font-bold flex flex-col items-center justify-center leading-none ${
                                  r.hole_points > 0 ? 'bg-green-100 text-green-700' :
                                  r.hole_points < 0 ? 'bg-red-100 text-red-700' :
                                  'bg-gray-100 text-gray-500'
                                }`}
                                title={`H${hole}: ${matchup.player1_name?.split(' ')[0]} ${r.p1_net} vs ${matchup.player2_name?.split(' ')[0]} ${r.p2_net}`}
                              >
                                <span className="text-[8px] text-gray-500">{hole}</span>
                                <span>{r.hole_points > 0 ? '+' + r.hole_points : r.hole_points < 0 ? r.hole_points : '0'}</span>
                              </div>
                            ))}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}
        </CardContent>
      </Card>
    </>
  );
}
